/** Missing optional metrics are zero; malformed metrics remain unavailable. */
export const normalizeOrderMetric = (value: unknown): number | null => {
  if (value == null) {
    return 0;
  }
  if (typeof value !== 'number' && typeof value !== 'string') {
    return null;
  }
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const sumOrderMetricValues = (
  values: readonly unknown[],
): number | null => {
  let total = 0;
  for (const value of values) {
    const numericValue = normalizeOrderMetric(value);
    if (numericValue === null) {
      return null;
    }
    total += numericValue;
  }
  return normalizeOrderMetric(total);
};

/** Sums already-computed metrics; null (unavailable) in any input makes the total unavailable. */
export const sumAvailableMetrics = (
  values: readonly (number | null | undefined)[],
): number | null => {
  return values.includes(null)
    ? null
    : sumOrderMetricValues(values);
};

export const subtractProcessedMetric = (
  total: number | null,
  processed: unknown,
): number | null => {
  const processedValue = normalizeOrderMetric(processed);
  return total === null || processedValue === null
    ? null
    : normalizeOrderMetric(total - processedValue);
};
